if (!customElements.get("up-header-autocomplete")) {
  customElements.define(
    "up-header-autocomplete",
    class extends HTMLElement {
      constructor() {
        super();
      }

      popularCache = null;

      connectedCallback() {
        // 计算并设置动态高度
        this.updateAutocompleteHeight();

        // 监听窗口大小改变和页面滚动，重新计算高度
        window.addEventListener("resize", () => {
          this.updateAutocompleteHeight();
        });

        // 监听 announcement bar 关闭事件
        window.addEventListener("announcementBarClosed", () => {
          this.updateAutocompleteHeight();
        });

        this.querySelector("input").addEventListener("input", (e) => {
          const value = e.target.value;

          if (value.length > 0) {
            this.querySelector(".clear-wrapper").style.display = "block";
            this.querySelector(".autocomplete-loading").style.display = "flex";
            this.debounceSearch(value);
          } else {
            // 当输入为空时，清理并隐藏 autocomplete
            this.querySelector(".clear-wrapper").style.display = "none";
            this.querySelector(".autocomplete-wrapper-inner").style.display =
              "none";
            this.querySelector(".autocomplete-loading").style.display = "none";
            document
              .querySelector(".shopify-section-header")
              ?.classList.remove("searchOpened");
            // 恢复 popular searches
            if (this.popularCache !== null) {
              this.querySelector(".autocomplete-wrapper-inner").innerHTML =
                this.popularCache;
            }
          }
        });

        this.querySelector("input").addEventListener("keydown", (event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            event.stopPropagation();
            if (this.querySelector("input").value) {
              location.href = `/search?q=${this.querySelector("input").value}`;
            }
          }
        });

        this.querySelectorAll(".popular-searches .suggestion").forEach(
          (suggestion) => {
            suggestion.addEventListener("click", (event) => {
              event.preventDefault();
              event.stopPropagation();

              if (suggestion.textContent.length > 0) {
                this.querySelector("input").value = suggestion.textContent;
                this.querySelector(".clear-wrapper").style.display = "block";
                document.querySelector(".autocomplete-overlay").style.display =
                  "block";
                this.debounceSearch(suggestion.textContent);
                // Auto-focus input after selecting suggestion
                this.querySelector("input").focus();
              }
            });
          },
        );

        this.querySelector(".clear-wrapper").addEventListener("click", () => {
          this.querySelector("input").value = "";
          this.querySelector(".clear-wrapper").style.display = "none";
          this.querySelector(".autocomplete-wrapper-inner").style.display =
            "none";
          this.querySelector(".autocomplete-loading").style.display = "none";
          // 恢复 popular searches
          if (this.popularCache !== null) {
            this.querySelector(".autocomplete-wrapper-inner").innerHTML =
              this.popularCache;
          }

          this.querySelector("input").focus();
        });

        this.querySelector(".search-icon").addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (this.querySelector("input").value) {
              location.href = `/search?q=${this.querySelector("input").value}`;
            }
          },
        );

        document
          .querySelector(".autocomplete-overlay")
          .addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();

            this.querySelector("input").value = "";
            this.querySelector(".autocomplete-wrapper-inner").style.display =
              "none";
            document.querySelector(".autocomplete-overlay").style.display =
              "none";
            this.querySelector(".clear-wrapper").style.display = "none";
            this.querySelector(".autocomplete-loading").style.display = "none";
            if (window.innerWidth > 1024) {
              document
                .querySelector(".header-searchField")
                .classList.remove("active");
              document
                .querySelector(".header-searchField-wrapper")
                .classList.remove("active");
            } else {
              document
                .querySelector(".header-searchField")
                .classList.remove("active");
              document
                .querySelector(".header-searchField-wrapper")
                .classList.remove("active");
            }

            document.querySelector("html").classList.remove("no-scroll");
            this.querySelector(".autocomplete-wrapper-inner").style.display =
              "block";
            if (this.popularCache !== null) {
              this.querySelector(".autocomplete-wrapper-inner").innerHTML =
                this.popularCache;
            }
            
            // Show announcement bar when overlay is clicked
            const announcementBar = document.querySelector("#announcement-bar");
            if (announcementBar) {
              announcementBar.style.display = "block";
              // Trigger header position update
              const header = document.querySelector("header-menu");
              if (header && header.updateHeaderTop) {
                header.updateHeaderTop();
              }
            }
          });

        this.querySelector(".close-icon").addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (window.innerWidth > 1024) {
            this.querySelector(".header-searchField-wrapper").classList.remove(
              "active",
            );
          } else {
            this.querySelector(".header-searchField-wrapper").classList.remove(
              "active",
            );
          }

          document
            .querySelector(".searchOpened")
            ?.classList.remove("searchOpened");
          this.querySelector(".autocomplete-wrapper-inner").style.display =
            "block";
          this.classList.remove("active");
          this.querySelector("input").value = "";
          this.querySelector(".autocomplete-wrapper-inner").style.display =
            "none";
          document.querySelector("html").classList.remove("no-scroll");
          document.querySelector(".autocomplete-overlay").style.display =
            "none";
          this.querySelector(".clear-wrapper").style.display = "none";
          this.querySelector(".autocomplete-loading").style.display = "none";
          if (this.popularCache !== null) {
            this.querySelector(".autocomplete-wrapper-inner").innerHTML =
              this.popularCache;
          }
          
          // Show announcement bar when search is closed
          const announcementBar = document.querySelector("#announcement-bar");
          if (announcementBar) {
            announcementBar.style.display = "block";
            // Trigger header position update
            const header = document.querySelector("header-menu");
            if (header && header.updateHeaderTop) {
              header.updateHeaderTop();
            }
          }
        });
      }

      updateAutocompleteHeight() {
        // 获取 header 高度
        const header = document.querySelector("#shopify-section-header");
        const headerHeight = header ? header.offsetHeight : 50; // 默认 50px

        // 获取 announcement bar 高度
        const announcementBar = document.querySelector(
          "#shopify-section-announcement-bar",
        );
        const announcementHeight =
          announcementBar && announcementBar.offsetHeight > 0
            ? announcementBar.offsetHeight
            : 0;

        // 设置 CSS 变量
        document.documentElement.style.setProperty(
          "--header-height",
          `${headerHeight}px`,
        );
        document.documentElement.style.setProperty(
          "--announcement-height",
          `${announcementHeight}px`,
        );
      }

      debounceTimeout;
      debounceSearch(value) {
        this.querySelector(".autocomplete-loading").style.display = "flex";
        this.querySelector(".autocomplete-wrapper-inner").style.display =
          "none";
        clearTimeout(this.debounceTimeout);

        this.debounceTimeout = setTimeout(() => {
          fetch(
            `/search/suggest?q=${encodeURIComponent(value)}&section_id=predictive-search`,
          )
            .then((response) => response.text())
            .then((text) => {
              const parser = new DOMParser();
              const html = parser.parseFromString(text, "text/html");
              this.querySelector(".autocomplete-wrapper-inner").style.display =
                "block";

              if (this.popularCache === null) {
                this.popularCache = document.querySelector(
                  ".autocomplete-wrapper-inner",
                ).innerHTML;
              }

              if (html.querySelector(".autocomplete-suggestions")) {
                this.querySelector(".autocomplete-wrapper-inner").innerHTML =
                  html.querySelector(".shopify-section").innerHTML;
              }

              fetch(`/search?q=${value}&section_id=autocomplete-search`)
                .then((response) => response.text())
                .then((text) => {
                  const parser = new DOMParser();
                  const searchHtml = parser.parseFromString(text, "text/html");
                  if (html.querySelector(".autocomplete-suggestions")) {
                    if (searchHtml.querySelector("autocomplete-results")) {
                      this.querySelector(".autocomplete-container").appendChild(
                        searchHtml.querySelector("autocomplete-results"),
                      );
                    } else {
                      this.querySelector(".autocomplete-container").appendChild(
                        searchHtml.querySelector(".autocomplete-no-results"),
                      );
                    }
                  } else {
                    this.querySelector(
                      ".autocomplete-wrapper-inner",
                    ).innerHTML =
                      searchHtml.querySelector(".shopify-section").innerHTML;
                  }
                  this.querySelector(".autocomplete-loading").style.display =
                    "none";
                });
            });
        }, 500); // 400ms debounce delay
      }
    },
  );
}

if (!customElements.get("autocomplete-results")) {
  customElements.define(
    "autocomplete-results",
    class extends HTMLElement {
      constructor() {
        super();
        this.flickity = null;
      }

      connectedCallback() {
        this.initLayout();

        // 监听窗口大小改变
        window.addEventListener("resize", () => {
          this.handleResize();
        });
      }

      initLayout() {
        const resultsList = this.querySelector(".results-list");

        if (window.innerWidth > 768) {
          // 桌面端使用 Flickity
          resultsList.classList.remove("mobile-grid");
          if (!this.flickity) {
            this.flickity = new Flickity(resultsList, {
              cellAlign: "left",
              adaptiveHeight: true,
              contain: true,
              pageDots: false,
              prevNextButtons: false,
            });
          }
        } else {
          // 移动端使用 grid 布局
          if (this.flickity) {
            this.flickity.destroy();
            this.flickity = null;
          }
          resultsList.classList.add("mobile-grid");
        }
      }

      handleResize() {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          this.initLayout();
        }, 100);
      }
    },
  );
}
